import React from "react";
import Skeleton from "react-loading-skeleton";

const CommunitySkeleton = ({ totalCount = 1, loading }) => {
  return (
    <>
      {loading && (
        <>
          {[...Array(totalCount)].map((_, index) => (
            <div key={index} className="card-community mt-4 shadow-sm">
              <div className="card-body">
                <div className="d-flex">
                  <Skeleton circle height={50} width={50} />
                  <div>
                    <Skeleton
                      style={{ marginLeft: "10px" }}
                      count={2}
                      height={20}
                      width={150}
                    />
                  </div>
                  <div className="ms-auto">
                    <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                  </div>
                </div>

                <p className="card-text mt-3 pera">
                  <Skeleton height={150} width={700} />
                </p>
                <Skeleton
                  style={{ marginLeft: "25px" }}
                  height={500}
                  width={800}
                />
              </div>
            </div>
          ))}
        </>
      )}
    </>
  );
};

export default CommunitySkeleton;
